import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [latestPosts, setLatestPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [postsRes, categoriesRes, configRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/posts?limit=6`),
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/categories`),
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config`)
      ]);

      const postsData = await postsRes.json();
      const categoriesData = await categoriesRes.json();
      const configData = await configRes.json();

      setLatestPosts(postsData.posts);
      setFeaturedPosts(postsData.posts.filter(p => p.featured).slice(0, 3));
      setCategories(categoriesData.categories);
      setConfig(configData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getCategoryBadgeClass = (category) => {
    const badges = {
      'RPGs': 'badge-purple',
      'Walkthroughs': 'badge-blue',
      'Tips & Tricks': 'badge-cyan',
      'Reviews': 'badge-magenta',
      'Gear & Setups': 'badge-blue',
      'News': 'badge-cyan'
    };
    return badges[category] || 'badge-purple';
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <main className="home" data-testid="home-page">
      {/* Hero Section */}
      <section className="hero" data-testid="hero-section">
        <div className="hero-background"></div>
        <div className="hero-glow"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-logo animate-fadeIn">
              <img 
                src="https://customer-assets.emergentagent.com/job_5b74c3d6-2b7f-4f5e-8a02-125e94fc2ed0/artifacts/ko7e8eh7_1000002309-removebg-preview.png" 
                alt="ClutchBabe9 Logo" 
                className="logo-image"
              />
            </div>
            <h1 className="hero-title brand-text animate-fadeIn" data-testid="hero-title">
              ClutchBabe9
            </h1>
            <p className="hero-tagline animate-fadeIn" data-testid="hero-tagline">
              Enter Clutch Mode
            </p>
            <p className="hero-description animate-fadeIn" data-testid="hero-description">
              Competitive gaming, honest reviews, and clutch-level tips for RPGs and more.
            </p>
            <div className="hero-cta animate-fadeIn" data-testid="hero-cta">
              <Link to="/blog" className="btn btn-primary" data-testid="hero-btn-blog">
                Read the Blog
              </Link>
              <a 
                href="https://youtube.com/@clutchbabe9?si=IVZiXzIxZMTc2y5t"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary"
                data-testid="hero-btn-youtube"
              >
                Watch on YouTube
              </a>
            </div>
            <div className="hero-social-icons animate-fadeIn">
              <a href="https://youtube.com/@clutchbabe9?si=IVZiXzIxZMTc2y5t" target="_blank" rel="noopener noreferrer" className="hero-social-icon" aria-label="YouTube">
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/clutchbabe9?igsh=ZWN3MzByMW02djUz" target="_blank" rel="noopener noreferrer" className="hero-social-icon" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
                </svg>
              </a>
              <a href="https://web.gameram.com/profile/ClutchBabe9" target="_blank" rel="noopener noreferrer" className="hero-social-icon" aria-label="Gameram">
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M15,6H13V4A2,2 0 0,0 11,2H9C7.89,2 7,2.89 7,4V6H5C3.89,6 3,6.89 3,8V9.47C3,10.07 3.28,10.62 3.74,10.97L7,13.5V21A1,1 0 0,0 8,22H12A1,1 0 0,0 13,21V13.5L16.26,10.97C16.72,10.62 17,10.07 17,9.47V8C17,6.89 16.11,6 15,6M9,4H11V6H9V4Z"/>
                </svg>
              </a>
              <a href="https://bsky.app/profile/clutchbabe9.bsky.social" target="_blank" rel="noopener noreferrer" className="hero-social-icon" aria-label="Bluesky">
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Posts */}
      {featuredPosts.length > 0 && (
        <section className="featured-section" data-testid="featured-section">
          <div className="container">
            <h2 className="section-title" data-testid="featured-title">
              Featured Posts
            </h2>
            <div className="featured-grid">
              {featuredPosts.map((post, index) => (
                <Link 
                  key={post._id} 
                  to={`/blog/${post.slug}`} 
                  className="featured-card glass-card"
                  data-testid={`featured-post-${index}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="featured-image">
                    <img src={post.featured_image} alt={post.title} />
                    <span className={`badge ${getCategoryBadgeClass(post.category)}`}>
                      {post.category}
                    </span>
                  </div>
                  <div className="featured-content">
                    <h3 className="featured-title">{post.title}</h3>
                    <p className="featured-excerpt">{post.excerpt}</p>
                    <div className="featured-meta">
                      <span>{new Date(post.publish_date).toLocaleDateString()}</span>
                      <span className="read-more">Read More →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* YouTube Section */}
      <section className="youtube-section" data-testid="youtube-section">
        <div className="container">
          <h2 className="section-title" data-testid="youtube-title">
            Latest from YouTube
          </h2>
          <p className="section-description">
            Check out my latest gaming content, walkthroughs, and tips on YouTube!
          </p>
          <div className="youtube-grid">
            {config && config.featured_video_id && (
              <div className="youtube-video-card glass-card">
                <div className="video-wrapper-inline">
                  <iframe
                    src={`https://www.youtube.com/embed/${config.featured_video_id}`}
                    title="Featured Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            )}
          </div>
          <div className="youtube-cta">
            <a 
              href="https://youtube.com/@clutchbabe9?si=IVZiXzIxZMTc2y5t"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Subscribe on YouTube
            </a>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="categories-section" data-testid="categories-section">
        <div className="container">
          <h2 className="section-title" data-testid="categories-title">
            Popular Categories
          </h2>
          <div className="categories-grid">
            {categories.map((category, index) => (
              <Link
                key={category}
                to={`/blog?category=${encodeURIComponent(category)}`}
                className="category-card glass-card"
                data-testid={`category-${index}`}
              >
                <span className={`category-icon ${getCategoryBadgeClass(category)}`}>
                  🎮
                </span>
                <h3 className="category-name">{category}</h3>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Posts */}
      <section className="latest-section" data-testid="latest-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" data-testid="latest-title">
              Latest Clutch Drops
            </h2>
            <Link to="/blog" className="btn btn-ghost" data-testid="view-all-btn">
              View All Posts
            </Link>
          </div>
          <div className="posts-grid">
            {latestPosts.slice(0, 6).map((post, index) => (
              <Link
                key={post._id}
                to={`/blog/${post.slug}`}
                className="post-card glass-card"
                data-testid={`latest-post-${index}`}
              >
                <div className="post-image">
                  <img src={post.featured_image} alt={post.title} />
                </div>
                <div className="post-content">
                  <span className={`badge ${getCategoryBadgeClass(post.category)}`}>
                    {post.category}
                  </span>
                  <h3 className="post-title">{post.title}</h3>
                  <p className="post-excerpt">{post.excerpt}</p>
                  <div className="post-meta">
                    <span>{new Date(post.publish_date).toLocaleDateString()}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Video */}
      {config && config.featured_video_id && (
        <section className="video-section" data-testid="video-section">
          <div className="container">
            <h2 className="section-title" data-testid="video-title">
              Latest Video
            </h2>
            <div className="video-wrapper glass-card">
              <iframe
                src={`https://www.youtube.com/embed/${config.featured_video_id}`}
                title="Featured Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                data-testid="video-embed"
              ></iframe>
            </div>
          </div>
        </section>
      )}

      {/* Newsletter */}
      <section className="newsletter-section" data-testid="newsletter-section">
        <div className="container">
          <div className="newsletter-card glass-card">
            <h2 className="newsletter-title" data-testid="newsletter-title">
              Stay in Clutch Mode
            </h2>
            <p className="newsletter-description" data-testid="newsletter-description">
              Never miss a post. Get the latest guides, reviews, and gaming news delivered to your inbox.
            </p>
            <NewsletterForm />
          </div>
        </div>
      </section>
    </main>
  );
}

function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
      } else {
        const data = await response.json();
        setStatus(data.detail || 'Subscription failed');
      }
    } catch (error) {
      setStatus('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="newsletter-form" data-testid="newsletter-form">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        required
        disabled={loading}
        className="newsletter-input"
        data-testid="newsletter-input"
      />
      <button 
        type="submit" 
        className="btn btn-primary"
        disabled={loading}
        data-testid="newsletter-submit"
      >
        {loading ? 'Subscribing...' : 'Subscribe'}
      </button>
      {status && (
        <p className={`form-message ${status === 'success' ? 'success' : 'error'}`} data-testid="newsletter-status">
          {status === 'success' ? '✅ Successfully subscribed!' : `⚠️ ${status}`}
        </p>
      )}
    </form>
  );
}

export default Home;
